import React, { useState } from "react";
import "../css/projects.css"; // New styles for the accordion design
import "../css/style.css"; // Global styles

function Projects() {
  const [expandedProject, setExpandedProject] = useState(null);

  const toggleProject = (index) => {
    setExpandedProject(expandedProject === index ? null : index);
  };

  const projectsData = [
    {
      title: "Cyber Threat Intelligence Platform",
      description:
        "Engineered a sophisticated CTI pipeline that revolutionized threat detection and response capabilities.",
      role: "Engineered a sophisticated CTI pipeline that revolutionized threat detection and response capabilities.",
      features: [
        "Integrated 10+ open-source threat feeds",
        "Automated lookup table generation for detection rules",
        "Real-time web traffic log enrichment",
        "Instant IOC alert triggering system",
        "Implementation of detection-as-code principles",
      ],
      techStack: ["Python", "Panther", "Netskope", "Detection Engineering"],
      date: "Sep 2025",
    },
    {
      title: "SAAS Management Dashboard",
      description:
        "Built a centralized SaaS application management dashboard to monitor utilization, budgeting, and forecasting for security, GRC, and IT tools at Sigma Computing.",
      role: "Developed automation scripts and integrations to audit tool utilization, perform health checks, and visualize insights in Sigma BI for proactive decision-making.",
      features: [
        "Automated data collection from security tools via APIs",
        "Implemented license utilization tracking against entitlements",
        "Built health check routines to detect outages, anomalies, and degradations",
        "Integrated with Snowflake for centralized visibility and reporting",
        "Created a Sigma BI dashboard for budgeting, renewal tracking, and forecasting",
      ],
      techStack: ["Python", "APIs", "Snowflake", "Sigma BI", "Automation"],
      date: "Aug 2025",
    },
    {
      title: "Year-long Phishing Simulation campaign",
      description:
        "Designed and deployed 12 monthly phishing simulation templates to run a year-long security awareness program for Sigma Computing employees.",
      role: "Created realistic phishing templates, scheduled monthly simulations, integrated automated reporting, and worked with security & HR to trigger follow-up training for at-risk users.",
      features: [
        "Built 12 unique, realistic phishing templates (one per month) covering different themes and social engineering techniques related to Sigma's environment",
        "Automated monthly campaign scheduling and delivery through the SANS simulation platform",
        "Integrated campaign telemetry with analytics for click/risk rates and per-department reporting",
        "Produced monthly executive and program-level dashboards to track progress and behavior changes over time",
      ],
      techStack: [
        "SANS Phishing Platform",
        "Analysis & Reporting",
        "Design & Simulation",
      ],
      date: "Aug 2025",
    },
    {
      title: "Neural Image-to-MIDI Generation with EMOPIA",
      role: "Developed a neural sequence generation system that composes symbolic music (MIDI) conditioned on mood-tagged images, leveraging deep learning models for multi-modal creativity.",
      features: [
        "Collected and preprocessed datasets: 5,000+ mood-labeled images (peaceful, playful, energetic, melancholy) and 1,078 MIDI clips from EMOPIA dataset.",
        "Extracted 519-dimensional image features using ResNet18 embeddings plus low-level color and texture statistics.",
        "Tokenized MIDI sequences with a customized REMI tokenizer to capture pitch, rhythm, velocity, and time-shifts.",
        "Implemented Conditional LSTM model that conditions music generation on image features at each timestep.",
        "Compared with Transformer-based approaches: chose Conditional LSTM for efficiency, controllability, and interpretability in symbolic music tasks.",
        "Evaluated performance via quantitative measures (emotion classification accuracy of 62.5%, token diversity) and subjective listening tests (alignment of generated music with image moods).",
        "Extended EMOPIA usage from emotion-label conditioning to novel cross-modal conditioning from visual to musical domain.",
      ],
      techStack: [
        "Python",
        "PyTorch",
        "LSTM (Conditional RNN)",
        "Transformers",
        "REMI Tokenizer",
        "ResNet18",
        "Deep Learning for Music Generation",
      ],
      github:
        "https://github.com/Anusha-RG/Neural-Image-to-MIDI-Generation-with-EMOPIA",
      date: "Jun 2025",
    },
    {
      title: "Game of Hearts: Greedy Algorithm Strategy",
      role: "Implemented a greedy algorithm-based decision-making strategy for the Hearts trick card game, including state representation, card evaluation, legal move enforcement, runtime complexity analysis, and visualization of gameplay under different rule modifications.",
      features: [
        "Modeled Hearts with extended rules (k suits, n cards per suit, modified Queen of Spades penalty).",
        "Designed state representation for players, trick history, lead suits, and penalties.",
        "Implemented greedy strategy with weighted scoring for penalty avoidance, trick-winning potential, and strategic discarding.",
        "Performed asymptotic complexity analysis: O((n×k/p)²) for single player and O(n²×k²/p) for multiplayer.",
        "Visualized gameplay and score evolution across different configurations (3-suit, 4-suit, 6-suit variants).",
        "Compared performance of single greedy vs. all-greedy players under multiple scenarios.",
      ],
      techStack: [
        "Python",
        "Greedy Algorithms",
        "Complexity Analysis",
        "Game Simulation",
        "Data Visualization",
      ],
      github: "https://github.com/Anusha-RG/Game-of-Hearts",
      date: "Mar 2025",
    },
    {
      title: "SafeTweet: AI for Cyberbullying Detection",
      description:
        "Built a machine learning pipeline to detect cyberbullying on social media platforms using NLP techniques and advanced models like DistilBERT.",
      role: "Implemented end-to-end data preprocessing, model training, and evaluation; compared baseline ML models with transformer-based approaches.",
      features: [
        "Collected and preprocessed 47k+ tweets dataset from Kaggle",
        "Implemented baseline models (Naive Bayes, Logistic Regression)",
        "Developed advanced models including KNN with PCA and DistilBERT",
        "Handled dataset imbalance with oversampling techniques",
        "Achieved highest accuracy of 87.7% with DistilBERT",
      ],
      techStack: ["Python", "scikit-learn", "PyTorch", "Transformers", "NLP"],
      github:
        "https://github.com/Anusha-RG/SafeTweet_AI-for-Cyberbullying-Detection-on-Social-Platforms",
      date: "Dec 2024",
    },
    {
      title: "Backend Buddy Development Toolbox",
      description:
        "Developed a comprehensive toolbox to streamline backend development workflows and ensure code quality.",
      role: "Developed a comprehensive toolbox to streamline backend development workflows and ensure code quality.",
      features: [
        "100% test coverage implementation",
        "Automated unit testing with Jest and Playwright",
        "Integrated CI/CD pipeline using GitHub Actions",
        "Advanced linting configurations",
      ],
      techStack: ["Jest", "Playwright", "GitHub Actions", "CI/CD"],
      github: "https://github.com/cse210-fa24-group4/cse210-fa24-group4",
      date: "Nov 2024",
    },
    {
      title: "LinkedIn Fraudulent Job Detection",
      description:
        "Developed a machine learning system to detect fraudulent job postings on LinkedIn using NLP techniques and classification algorithms.",
      role: "Designed and implemented the full ML pipeline including data preprocessing, feature engineering, model training, and evaluation; combined Kaggle datasets with LinkedIn job data and user survey insights.",
      features: [
        "Analyzed 140k+ job postings from Kaggle and LinkedIn datasets",
        "Implemented baseline models (Multinomial Naive Bayes, Logistic Regression)",
        "Extracted linguistic and recruiter-based fraud indicators (keywords, suspicious phone numbers, location targeting)",
        "Addressed class imbalance with resampling techniques",
        "Generated insights into scam trends such as targeted job roles and geographic hotspots",
      ],
      techStack: ["Python", "scikit-learn", "pandas", "NumPy", "NLP"],
      github: "https://github.com/Anusha-RG/LinkedIn-Fraudulent-Job-Detection",
      date: "Oct 2024",
    },
    {
      title: "Incident Response and Threat Mitigation",
      type: "Professional Experience",
      date: "Feb 2024",
      github: null,
      description:
        "Led a critical incident response effort during a major cyberattack, successfully protecting organizational assets.",
      role: "Led a critical incident response effort during a major cyberattack, successfully protecting organizational assets.",
      features: [
        "Analyzed 10,000+ assets for vulnerabilities",
        "Reduced potential impact by 90%",
        "Implemented effective mitigation strategies",
        "Ensured zero data exfiltration during containment",
      ],
      techStack: [
        "Security Operations",
        "Incident Response",
        "Threat Analysis",
      ],
    },
    {
      title: "Malware Threat Detection and Remediation",
      type: "Professional Experience",
      date: "Oct 2023",
      github: null,
      description:
        "Spearheaded a rapid response initiative to combat trojan attacks across the organization.",
      role: "Spearheaded a rapid response initiative to combat trojan attacks across the organization.",
      features: [
        "Mitigated trojan attack across 200+ endpoints in 4 days",
        "Protected 140+ VIP and user accounts",
        "Uncovered 10 dormant trojans through advanced threat hunting",
        "Reduced malicious downloads by 50% through improved filtering",
      ],
      techStack: ["Threat Hunting", "ASR Rules", "Web Filtering"],
    },
    {
      title: "Handling Imbalanced Data in Credit Card Fraud Detection",
      role: "Implemented end-to-end ML pipeline for fraud detection: preprocessing, feature scaling, applied resampling (SMOTE, undersampling, hybrid methods), trained and compared classifiers (Logistic Regression, Random Forest, XGBoost, SVM, KNN), and evaluated using Precision, Recall, F1-score, and ROC-AUC to address class imbalance.",
      features: [
        "Analyzed highly imbalanced credit card fraud dataset (≈284,807 transactions, 492 fraud cases).",
        "Applied resampling techniques (Random Undersampling, SMOTE, SMOTEENN) to balance datasets.",
        "Implemented baseline models (Logistic Regression, Decision Tree, Random Forest, XGBoost, SVM, KNN).",
        "Evaluated models with metrics suited for imbalance (Precision, Recall, F1-score, ROC-AUC).",
        "Identified Random Forest + SMOTE as achieving the best trade-off between fraud detection and false positives.",
      ],
      techStack: [
        "Python",
        "scikit-learn",
        "imbalanced-learn",
        "XGBoost",
        "NumPy",
        "pandas",
      ],
      github:
        "https://github.com/Anusha-RG/HANDLING-IMBALANCED-DATA-IN-CREDIT-CARD-FRAUD-DETECTION",
      date: "Jan 2022",
    },
    {
      title: "Blackhole Detection & Prevention in VANETs",
      role: "Designed and implemented the attack creation and mitigation pipeline: modified AODV source (aodv.cc / aodv.h), authored TCL simulation scripts for NS-2, generated Blackhole Detection Dataset (BDD) from trace files, developed offline and online detection strategies, implemented AWK analysis scripts, and performed experimental evaluation (PDR, throughput, E2E delay).",
      features: [
        "Created optimized blackhole attackers by modifying AODV (set nodes as 'hacker', spoofed RREP sequence numbers and hop counts).",
        "Built multiple NS-2 scenarios (single & collaborative blackholes) and real-world VANET scenarios using SUMO + OpenStreetMap for mobility traces.",
        "Produced a Blackhole Detection Dataset (BDD) from NS-2 traces and evaluated an offline ML detection pipeline (~80% detection in experiments).",
        "Implemented an online prevention mechanism (RREP-saving + sequence-number check) to isolate malicious nodes without introducing extra packet types.",
        "Automated QoS analysis using AWK scripts to compute throughput, packet delivery ratio, and end-to-end delay; visualized results with NAM and plotted metrics to compare AODV vs. BH-AODV.",
      ],
      techStack: [
        "NS-2 (TCL, NAM)",
        "SUMO + OpenStreetMap (OSM) mobility",
        "C / C++ (aodv.cc, aodv.h modifications)",
        "AWK (trace analysis)",
        "Network simulation & protocols (AODV, TCP/UDP)",
      ],
      github:
        "https://github.com/Anusha-RG/Blackhole-Detection-Prevention-in-VANETs",
      date: "Oct 2021",
    },
  ];

  return (
    <div className="projects-page-container">
      <h1 className="section-title text-center mb-5">Projects</h1>
      <p className="projects-intro-text">
        A selection of my most impactful projects, from research prototypes to
        community infrastructure.
      </p>

      <div className="accordion-container">
        {projectsData.map((project, index) => (
          <div className="accordion-item" key={index}>
            <div
              className="accordion-header"
              onClick={() => toggleProject(index)}
            >
              <div className="title-date-wrapper">
                <h2 className="accordion-title">{project.title}</h2>
                {project.date && (
                  <span className="project-date">{project.date}</span>
                )}
              </div>
              <span className="accordion-toggle-icon">
                {expandedProject === index ? "-" : "+"}
              </span>
            </div>
            {expandedProject === index && (
              <div className="accordion-content">
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-github-link"
                  >
                    View on GitHub
                  </a>
                )}

                <h5 className="project-section-subheading">My Role</h5>
                <p className="project-role-description">{project.role}</p>

                <h5 className="project-section-subheading">Key Features</h5>
                <ul className="project-features-list">
                  {project.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>

                <h5 className="project-section-subheading">Tech Stack</h5>
                <div className="project-tech-stack-buttons">
                  {project.techStack.map((tech, i) => (
                    <span key={i} className="tech-button">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
